import React from 'react';
import { useParams } from 'react-router-dom';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css';

function Season2Page() {
  const{id}=useParams()
  return (
    <div>
      <video
        controls
        width="100%"
        src={`https://www.eiforiya.site/serias2/${id}`}
      />
    </div>
  )
}

export default Season2Page
